export default {
    en: {
        common: {
        },
        addRelationship: 'AddRelationship',
    },
    cn: {
        search: {
            orgRelationship: '机构关系',
            companyRelationship: '公司关系',
            pwcContact: 'PwC认识',
            searchTitle: '查询',
        },
        common: {
            commitTip: '提交',
            commitSuccess: '添加成功',
            home: '首页',
            search: '查询',
            add: '添加',
            edit: '编辑',
            cancel: '取消',
            userInfo: '我的',
            orgnazation: '机构',
            filter: '筛选',
            searchAll: '全部',
            title: '职务',
            responsibility: '职能',
            relationDeepth: '关系深度',
            industry: '行业',
            investmentPreference: '投资阶段',
            investmentType: '投资类型',
            searchHistory: '搜索历史',
            orgStage: '主投阶段',
            orgIndustry: '主投领域',
            companyIndustry: '行业领域',
            companyRound: '当前轮次',
            companyInvestmentDate: '最新获投',
            newsType: '新闻类别',
            marketPeriod: '时间',
            ok: '确定',
            reset: '重置',
            country: '国家',
            investmentRound: '轮次',
            latestInvestment: '最新获投',
            noMore: '没有更多了',
            edit: '编辑',
            viewMore: '更多',
            shrink: '收起',
            filter: '筛选',
            stockExchange: '上市地点',
            dates: '时间',
            guidTips: '请填写GUID',
            passwordTips: '请填写密码',
            userIndustry: '专注行业',
        },
        identifyRelationship: '识别导入',
        addRelationship: '添加关系',
        viewRelationship: '编辑关系',
        PEOrganizationName: 'PE/VC机构',
        PEOrganizationNameTips: '请填写基金机构名称（中文/英文）',
        PEOrganizationNameEn: 'PE/VC 机构(英文)',
        PEOrganizationNameEnTips: '填写基金机构英文名称',
        peContactName: 'PE/VC联系人',
        peContactNameTips: '请填写基金机构联系人姓名（Last Name+First Name）',
        peContactNameEn: 'PE/VC 联系人(英文)',
        peContactNameEnTips: '填写英文Last Name + First Name',
        CompanyName: '公司名称',
        CompanyNameTips: '请填写公司名称（中文/英文）',
        CompanyNameEn: '公司(英文)',
        CompanyNameEnTips: '填写被投公司英文名称',
        CompanyContactName: '公司联系人',
        CompanyContactNameTips: '请填写公司联系人姓名（Last Name+First Name）',
        CompanyContactNameEn: '公司联系人(英文)',
        CompanyContactNameEnTips: '填写英文Last Name + First Name',
        CompanyContactPosition: '级别',
        CompanyContactPositionTips: '请填写公司联系人级别',
        remark: '备注',
        remarkTips: '请填写备注',
        Responsibility: '职能',
        ResponsibilityTips: '若选其他，请注明',
        Title: '级别',
        TitleTips: '若选其他，请注明',
        Position: '职务',
        PositionTips: '请填写基金机构联系人职务',
        PositionSelectTips: '请选择基金机构联系人职务',
        RelationDeepth: '关系深度',
        RelationDeepthTips: '请选择关系深度',
        Industries: '投资专注行业',
        IndustriesTips: '若选其他，请注明',
        InvestmentPreferences: '投资偏好阶段',
        InvestmentPreferencesTips: '请选择',
        peType: '主要投资类型',
        peTypeTips: '若选其他，请注明',
        userPEVC: '我的关系',
        userCollection: '我的收藏',
        userQuery: '我的查看记录',
        userSetting: '设置',
        contactManager: '联系管理员',
        langeChange: 'En',
        logout: '退出',
        complete: '完成',
        relationship: '关系',
        orgContact: 'PwC认识',
        investdCompany: '公司',
        orgName: '机构名',
        collection: '收藏',
        collected: '已收藏',
        filter: '筛选',
        relationDeepDesc: '按关系深度降序',
        addRelationshipSuccess: '添加关系成功',
        peLink: 'Private Equity Link',
        importNews: '要闻',
        newsFrom: '来自：',
        marketNewsFrom: '主要来自：',
        searchOtherOrg: '查看全部机构 >',
        searchOtherCompany: '查看全部被投公司 >',
        searchOtherContact: '查看全部联系人 >',
        addRelationshipTickes: 'S后跳转至我的PE/VC关系',
        viewMyRelationship: '查看关系详情',
        myHistory: '我的查看记录',
        relation: '关联',
        detailContactor: '位合伙人',
        notEmptyComment: '评论不能为空',
        recognize: '我认识他/她',
        recognized: '我已认识他/她',
        money: '金额',
        fundingEvent: '投资事件',
        existEvent: '退出事件',
        existEventIPO: 'IPO',
        existEventTrade: 'Trade Sales',
        fundingNews: '募资活动',
        newsTips: '敬请留意：',
        versionInfo: '版本信息',
        newsTips1: '"市场情报”或“Market Intelligence”栏目的市场讯息均来源于公开新闻或外部数据库，交易线索（包含出售和购买）的真实性尚未得到直接确认，仅供普华永道员工开拓潜在业务机会时作一般了解和适当使用，我们对其真实性不承担任何责任。如有需要，建议您与涉及的机构/公司/股东先取得联系 ',
    }
}


// WEBPACK FOOTER //
// ./src/lang/lang.js